import React from 'react';
import ReactDOM from 'react-dom';
import { LoaderProps } from './types';
import { LoaderWrapper, LoaderStyled, TabLoader } from './styles';

/**
 * Component that creates default visual loader component on page
 */
const Loader = React.forwardRef<HTMLDivElement, LoaderProps>(
  (
    { isFull, isAbsolute, isTransparent = true, isVisible = true, ...rest },
    ref
  ) => {
    const loaderRender = (
      <LoaderWrapper
        data-testid="custom-loader-component"
        isFull={isFull}
        isAbsolute={isAbsolute}
        isVisible={isVisible}
        isTransparent={isTransparent}
        {...rest}
      >
        <LoaderStyled ref={ref}>
          <TabLoader />
          <TabLoader />
          <TabLoader />
          <TabLoader />
        </LoaderStyled>
      </LoaderWrapper>
    );

    return isFull
      ? ReactDOM.createPortal(
          loaderRender,
          document.querySelector('body') as Element
        )
      : loaderRender;
  }
);

export default Loader;
